// The technical skills listed on Carlos's resume, grouped as they are there:
// languages, then frameworks and platforms, then infrastructure and tooling.
// Each avatar is the tool's own GitHub organisation, so the marks stay correct
// without checking logo files into the repo.
//
// To change the marquee, edit this list -- one entry per pill. `id` is the
// GitHub numeric account id (github.com/<org>.png redirects to it).
const tools = [
  // Languages
  { name: "Python", org: "python", id: 1525981 },
  { name: "TypeScript", org: "microsoft", id: 6154722 },
  { name: "Rust", org: "rust-lang", id: 5430905 },
  { name: "Java", org: "openjdk", id: 41768318 },
  { name: "C++", org: "isocpp", id: 13841574 },
  { name: "Perl", org: "Perl", id: 3585411 },

  // Frameworks & platforms
  { name: "React", org: "reactjs", id: 6412038 },
  { name: "Next.js", org: "vercel", id: 14985020 },
  { name: "FastAPI", org: "fastapi", id: 156354296 },
  { name: "Django", org: "django", id: 27804 },
  { name: "GraphQL", org: "graphql", id: 12972006 },
  { name: "Tauri", org: "tauri-apps", id: 54536011 },
  { name: "PostgreSQL", org: "postgres", id: 177543 },

  // Infrastructure & tools
  { name: "Kubernetes", org: "kubernetes", id: 13629408 },
  { name: "Docker", org: "docker", id: 5429470 },
  { name: "Terraform", org: "hashicorp", id: 761456 },
  { name: "AWS", org: "aws", id: 2232217 },
  { name: "GitHub Actions", org: "actions", id: 44036562 },
  { name: "Datadog", org: "DataDog", id: 365230 },
  { name: "Grafana", org: "grafana", id: 7195757 },
  { name: "Sentry", org: "getsentry", id: 1396951 },
  { name: "Git", org: "git", id: 18133 },
];

export default tools.map((tool) => ({
  ...tool,
  url: `https://github.com/${tool.org}`,
  avatar: `https://avatars.githubusercontent.com/u/${tool.id}?s=80&v=4`,
}));
